import { ICellRendererParams } from 'ag-grid-community';
import { IOpoForList } from '@nkr/models/index';
import { OpoAction } from './opo-action';
import OverlayMenuButton from '@nkr/components/overlay-menu-button';

const menuItemList = [
    { action: OpoAction.Edit, title: 'Edit' },
    { action: OpoAction.Delete, title: 'Delete' },
    { action: OpoAction.Contacts, title: 'Manage Contacts' },
    { action: OpoAction.Files, title: 'Manage Files' },
    { action: OpoAction.OpenPortal, title: 'Open OPO Portal' },
    { action: -1, title: '' }
];

interface IProps {
    pullRight?: boolean,
    onMenuDisplayed?: (id: number) => void,
    onMenuToggle: (show: boolean) => void,
    onItemSelected: (id: number, action: number) => void
}

const ActionButtonRenderer = (props: ICellRendererParams & IProps) => {
    const handleMenuToggle = (show: boolean) => {
        props.onMenuToggle(show);
    };

    const handleMenuSelection = (id: any, action: number) => {
        props.onItemSelected(id, action);
    }

    const getUrl = (action: number, id: number) => {
        if (action == OpoAction.OpenPortal) {
            return `/opo-portal/${id}`;
        }

        return null;
    };

    const getMenuItems = () => {
        const data = props.data as IOpoForList;

        let menuItems = [
            OpoAction.Edit,
            OpoAction.Delete,
            -1,
            OpoAction.Contacts,
            -1,
            OpoAction.Files,
            -1,
            OpoAction.OpenPortal
        ];

        return menuItems;
    };

    const dataLength = props.api.getModel().getRowCount();
    const dropup = dataLength <= 18 ? false : props.rowIndex + 1 > dataLength - 6;

    const menuItems = getMenuItems().map(item => {
        return menuItemList.find(x => x.action == item);
    });

    const menu = menuItems.map(item => {
        let url = item.action != -1 ? getUrl(item.action, props.data.id) : null;
        let id = item.action >= 0 ? props.data.id : 'div-' + props.data.id + '-' + Math.random() * 10000;

        if (url == null) {
            if (item.action >= 0) {
                return { id, action: item.action, include: true, selectable: true, element: <>{item.title}</> };
            } else {
                return { id, action: item.action, include: true, selectable: false, element: <div style={{ height: 10 }}></div>, divider: true };
            }
        } else {
            return { id, action: item.action, include: true, selectable: false, element: <a href={url} target={item.action == OpoAction.OpenPortal ? '_blank' : undefined} rel='noopener'>{item.title}</a> };
        }
    });

    return (
        <div style={{ width: '100%', textAlign: 'center' }}>
            <OverlayMenuButton
                menu={menu}
                bsStyle='primary'
                bsSize='xs'
                title='Actions'
                listItemStyle={{ padding: '2px 7.5px', fontSize: 14 }}
                includeCaret={true}
                onToggle={handleMenuToggle}
                onSelect={handleMenuSelection}
            />
        </div>
    );
}

export default ActionButtonRenderer;